import { render, staticRenderFns } from "./ObjectDecisionCell.vue?vue&type=template&id=f13aae06"
import script from "./ObjectDecisionCell.vue?vue&type=script&lang=js"
export * from "./ObjectDecisionCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports